var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLevelBackgroundNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0l31.177 18v36L32 72 .823 54V18L32 0z",
    fill: "#111318"
  })));
}

export default SvgLevelBackgroundNew;